import { DocumentTypeEnum } from '../../legacy/shared-types';

export interface IUploadFileDto {
  file: File;
  documentType: string;
}

export interface IUploadFilesDto {
  filesData: IUploadFileDto[];
  applicationId: number | string;
  individualId?: string;
}

export interface IBtlDocument {
  id: number;
  applicationId: string | null;
  legacyApplicationId: string | null;
  caseId: string;
  customerId: string | null;
  legacyCustomerId: string | null;
  type: string;
  description: string | null;
  originalFileName: string;
  systemName: string;
  source: string;
  uploadedBy: string;
  createdAt: string;
  uploadedAt: string;
  isDeleted: boolean | null;
  deletedAt: string | null;
}

export interface IBtlUploadDocumentMetadata {
  caseId: string;
  customerId: string | null;
  type: string;
  source: 'EXTERNAL';
  uploadedBy: string;
  description?: string | null;
}

export const filesTypesOptions = Object.values(DocumentTypeEnum);
